import { AutomationCommand, AutomationCommandProps } from "../types/automation";
import { AutomationPayloads, SettingsProps } from "../types/payloads";
import { Topic, Topics } from "../types/topics";
import GoToMapCommand from "./GoToMapCommand";
import LoadProjectCommand from "./LoadProjectCommand";
import LoadSavedFilterCommand from "./LoadSavedFilterCommand";
import LoadWellListCommand from "./LoadWellListCommand";
import OpenScreenshotCommand from "./OpenScreenshotCommand";
import SetChartCommand from "./SetChartCommand";
import SetFocusCommand from "./SetFocusCommand";
import TakeChartScreenshotCommand from "./TakeChartScreenshotCommand";
import TakeMapScreenshotCommand from "./TakeMapScreenshotCommand";
import { GoToMapSettings } from "./payload-settings/GoToMapSettings";
import { LoadProjectSettings } from "./payload-settings/LoadProjectSettings";
import { LoadSavedFilterSettings } from "./payload-settings/LoadSavedFilterSettings";
import { SetChartSettings } from "./payload-settings/SetChartSettings";
import { SetFocusSettings } from "./payload-settings/SetFocusSettings";
import { TakeChartScreenshotSettings } from "./payload-settings/TakeChartScreenshotSettings";
import { TakeMapScreenshotSettings } from "./payload-settings/TakeMapScreenshotSettings";

type ComponentPair = {
  Command: React.FC<AutomationCommandProps>;
  Settings: React.FC<SettingsProps<AutomationPayloads>> | undefined;
};

export const renderComponentMap: Record<Topic, ComponentPair> = {
  [Topics.LoadSavedFilter]: {
    Command: LoadSavedFilterCommand,
    Settings: LoadSavedFilterSettings
  },
  [Topics.SetChartSettings]: { Command: SetChartCommand, Settings: SetChartSettings },
  [Topics.TakeChartScreenshot]: {
    Command: TakeChartScreenshotCommand,
    Settings: TakeChartScreenshotSettings
  },
  [Topics.OpenMapScreenshot]: { Command: OpenScreenshotCommand, Settings: undefined },
  [Topics.OpenChartScreenshot]: { Command: OpenScreenshotCommand, Settings: undefined },
  [Topics.WellList]: { Command: LoadWellListCommand, Settings: undefined },
  [Topics.GoTo]: { Command: GoToMapCommand, Settings: GoToMapSettings },
  [Topics.LoadProject]: { Command: LoadProjectCommand, Settings: LoadProjectSettings },
  [Topics.TakeMapScreenshot]: {
    Command: TakeMapScreenshotCommand,
    Settings: TakeMapScreenshotSettings
  },
  [Topics.SetFocus]: { Command: SetFocusCommand, Settings: SetFocusSettings },
  //get info
  [Topics.GetChartSettings]: undefined,
  [Topics.GetProjectIdAndSavedFilterInfo]: undefined,
  [Topics.GetMapLocationAndZoom]: undefined,
  [Topics.GetChartScreenshotSettings]: undefined,
  [Topics.GetMapScreenshotSettings]: undefined
};

export function getRenderComponent(command: AutomationCommand) {
  const Component = renderComponentMap[command.topic];
  return Component ? <Component.Command command={command} /> : null;
}
